const info = {
  ZH: { //中文翻译
    title: '阅读《CAMDS用户使用守则》',
    determine: '确定',
    nextDisplay: '下次登录时不再显示该页面',
    agree: '阅读并同意',
    title1: 'CAMDS 12.1版本更新说明'
  },
  EN: { //英文翻译
    title: 'Read the Use Conditions',
    determine: 'ok',
    nextDisplay: 'Don\'t show it again next time.',
    agree: 'read and agree',
    title1: 'CAMDS V12.1 Update Notes'
  }
}
export default info //需要暴露出去
